import { doc, getDoc } from 'firebase/firestore';
import { FirestoreCollections, firestore } from '../../../firebase.config';
import UserDoc from '../../models/UserDoc';
import Failure from '../../../core/Failure';

async function getUserById(userId: string): Promise<UserDoc | null> {
  try {
    const db = firestore;

    const userDocRef = await getDoc(
      doc(db, FirestoreCollections.users, userId)
    );

    if (!userDocRef.exists()) {
      return null;
    }

    const user = UserDoc.fromFirestore(userDocRef);

    return user;
  } catch (e) {
    console.error('error: ', e);
    throw new GetUserByIdFailure();
  }
}

export class GetUserByIdFailure extends Failure {
  constructor(message = 'Unknown error', code = 'unknown-error') {
    super(message, code);
  }
}

export default getUserById;
